
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/social-media-marketing-services",
      function () {
        return require("private-next-pages/services/social-media-marketing-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/social-media-marketing-services"])
      });
    }
  